import "./App.css";
import io from "socket.io-client";
import { useState } from "react";
import Chat from "./Chat";

console.log(
  "backend url:",
  process.env.REACT_APP_BACK_END_URL
    ? process.env.REACT_APP_BACK_END_URL
    : "http://localhost:3001"
);

const socket = io.connect(
  process.env.REACT_APP_BACK_END_URL
    ? process.env.REACT_APP_BACK_END_URL
    : "http://localhost:3001"
);

function App() {
  const [username, setUsername] = useState("");
  const [room, setRoom] = useState("");
  const [showChat, setShowChat] = useState(false);

  const joinRoom = () => {
    if (username !== "" && room !== "") {
      socket.emit("join_room", room);
      setShowChat(true);
    }
  };

  return (
    <div className="App">
      {showChat ? (
        <Chat socket={socket} username={username} room={room} />
      ) : (
        <div className="joinChatContainer">
          <h3>Join A Chat</h3>
          <input
            type="text"
            placeholder="John..."
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="text"
            placeholder="Room ID..."
            value={room}
            onChange={(e) => setRoom(e.target.value)}
          />
          <button onClick={joinRoom}>Join A Room</button>
        </div>
      )}
    </div>
  );
}

export default App;
